export default __webpack_public_path__ + "static/media/pro-voice-cloning-option.628ab8f0.svg";